import React from 'react';

import PropTypes from 'prop-types';

import {
    CATEGORY_TRANSFER_FROM_CARD,
    CATEGORY_TRANSFER_FROM_CARD_110,
    CATEGORY_TRANSFER_FROM_CREDIT_CARD_112,
    CATEGORY_TRANSFER_FROM_DEBIT_CARD_111,
    PAYMENT_APPLE_PAY,
    PAYMENT_BANK_CARD,
    PAYMENT_BANK_CARD_110,
    PAYMENT_CREDIT_BANK_CARD_112,
    PAYMENT_DEBIT_BANK_CARD_111,
    PAYMENT_GLOBAL_ACCOUNT,
    PAYMENT_GOOGLE_PAY,
    PAYMENT_PAYPAL,
} from 'apps/auth/constants/Constants';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';

import DcAccountsWithPaymentMethod from './dcSources/DcAccountsWithPaymentMethod';
import DcCards from './dcSources/DcCards';
import DcGaAccounts from './dcSources/DcGaAccounts';
import PaymentMethod from './PaymentMethod';

const RenderPaymentMethod = ({
    formName,
    returnToCalculator,
    userCountryId,
    clickHandler,
    paymentMethod,
    dcSources,
    submitRef,
    modalRef,
    canShowAmlLevelUpgrade = false,
    canShowOowFlow = false,
    icon,
    badge,
    actionBanner,
    getPaymentFlow,
    category,
    recipientType,
    paymentMethodCategory,
    toCountryCode,
    toCurrencyCode,
    isIncomplete,
    popupRef,
}) => {
    const isGooglePay = paymentMethod.method === PAYMENT_GOOGLE_PAY;
    const isApplePay = paymentMethod.method === PAYMENT_APPLE_PAY;
    const isBankCard = paymentMethod.method === PAYMENT_BANK_CARD;
    const isCanadaVisaBankCard = paymentMethod.method === PAYMENT_BANK_CARD_110;
    const isDebitBankCard = paymentMethod.method === PAYMENT_DEBIT_BANK_CARD_111;
    const isCreditBankCard = paymentMethod.method === PAYMENT_CREDIT_BANK_CARD_112;
    const isGlobalAccount = paymentMethod.method === PAYMENT_GLOBAL_ACCOUNT;
    const isPayPal = paymentMethod.method === PAYMENT_PAYPAL;
    const hasSrc = isPayPal;

    if (isGooglePay || isApplePay) {
        return (
            <PaymentMethod
                formName={formName}
                paymentMethod={paymentMethod}
                clickHandler={clickHandler}
                returnToCalculator={returnToCalculator}
                src={`${URL_IMAGES_I}/${isGooglePay ? 'google-pay-logo-56' : 'apple-pay-logo'}.png`}
                diskVariant="transparent"
                withoutRadius={true}
                mobilePayAlt={paymentMethod.name}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                paymentMethodCategory={paymentMethodCategory}
                category={category}
                popupRef={popupRef}
            />
        );
    }
    if (isBankCard) {
        return (
            <DcCards
                formName={formName}
                userCountryId={userCountryId}
                filterCategories={[CATEGORY_TRANSFER_FROM_CARD]}
                cards={dcSources?.CARD}
                clickHandler={clickHandler}
                paymentMethod={paymentMethod}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                category={category}
                recipientType={recipientType}
                paymentMethodCategory={paymentMethodCategory}
                submitRef={submitRef}
                toCountryCode={toCountryCode}
                toCurrencyCode={toCurrencyCode}
                isIncomplete={isIncomplete}
                popupRef={popupRef}
            />
        );
    }
    if (isCanadaVisaBankCard) {
        return (
            <DcCards
                formName={formName}
                userCountryId={userCountryId}
                filterCategories={[CATEGORY_TRANSFER_FROM_CARD_110]}
                cards={dcSources?.CARD}
                clickHandler={clickHandler}
                paymentMethod={paymentMethod}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                category={category}
                recipientType={recipientType}
                paymentMethodCategory={paymentMethodCategory}
                submitRef={submitRef}
                toCountryCode={toCountryCode}
                toCurrencyCode={toCurrencyCode}
                isIncomplete={isIncomplete}
                popupRef={popupRef}
            />
        );
    }
    if (isDebitBankCard) {
        return (
            <DcCards
                formName={formName}
                userCountryId={userCountryId}
                filterCategories={[CATEGORY_TRANSFER_FROM_DEBIT_CARD_111]}
                cards={dcSources?.CARD}
                clickHandler={clickHandler}
                paymentMethod={paymentMethod}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                category={category}
                recipientType={recipientType}
                paymentMethodCategory={paymentMethodCategory}
                submitRef={submitRef}
                toCountryCode={toCountryCode}
                toCurrencyCode={toCurrencyCode}
                isIncomplete={isIncomplete}
                popupRef={popupRef}
            />
        );
    }
    if (isCreditBankCard) {
        return (
            <DcCards
                formName={formName}
                userCountryId={userCountryId}
                filterCategories={[CATEGORY_TRANSFER_FROM_CREDIT_CARD_112]}
                cards={dcSources?.CARD}
                clickHandler={clickHandler}
                paymentMethod={paymentMethod}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                category={category}
                recipientType={recipientType}
                paymentMethodCategory={paymentMethodCategory}
                submitRef={submitRef}
                toCountryCode={toCountryCode}
                toCurrencyCode={toCurrencyCode}
                isIncomplete={isIncomplete}
                popupRef={popupRef}
            />
        );
    }
    if (isGlobalAccount) {
        return (
            <DcGaAccounts
                accounts={dcSources?.GLOBAL_ACCOUNT}
                paymentMethod={paymentMethod}
                formName={formName}
                returnToCalculator={returnToCalculator}
                clickHandler={clickHandler}
                badge={badge}
                actionBanner={actionBanner}
                commission={paymentMethod?.commission}
                getPaymentFlow={getPaymentFlow}
                recipientType={recipientType}
            />
        );
    }
    return (
        <>
            <DcAccountsWithPaymentMethod
                formName={formName}
                paymentMethod={paymentMethod}
                clickHandler={clickHandler}
                returnToCalculator={returnToCalculator}
                dcSources={dcSources}
                submitRef={submitRef}
                modalRef={modalRef}
                icon={icon}
                badge={badge}
                actionBanner={actionBanner}
            />
            <PaymentMethod
                formName={formName}
                category={category}
                paymentMethod={paymentMethod}
                clickHandler={clickHandler}
                canShowAmlLevelUpgrade={canShowAmlLevelUpgrade}
                canShowOowFlow={canShowOowFlow}
                returnToCalculator={returnToCalculator}
                icon={!hasSrc ? icon : null}
                src={isPayPal ? `${URL_IMAGES_I}/paypal-logo.png` : null}
                diskVariant={hasSrc ? 'transparent' : null}
                badge={badge}
                actionBanner={actionBanner}
                getPaymentFlow={getPaymentFlow}
                paymentMethodCategory={paymentMethodCategory}
                recipientType={recipientType}
                modalRef={modalRef}
                popupRef={popupRef}
            />
        </>
    );
};

RenderPaymentMethod.propTypes = {
    formName: PropTypes.string.isRequired,
    returnToCalculator: PropTypes.func.isRequired,
    clickHandler: PropTypes.func.isRequired,
    paymentMethod: PropTypes.object.isRequired,
    dcSources: PropTypes.object.isRequired,
    submitRef: PropTypes.object.isRequired,
    modalRef: PropTypes.object.isRequired,
    canShowAmlLevelUpgrade: PropTypes.bool,
    canShowOowFlow: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    badge: PropTypes.string,
    actionBanner: PropTypes.string,
    getPaymentFlow: PropTypes.func.isRequired,
    category: PropTypes.number.isRequired,
    paymentMethodCategory: PropTypes.string,
};

export default RenderPaymentMethod;
